import React from 'react'
import { useRouteMatch, Switch, Route } from "react-router-dom";
import ListDetails from "../../pages/contacts/imported/ListDetails"
import ImportedContactsLists from '../../pages/contacts/imported/ImportedLists';

export default function ImportedContacts() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            {/* <Route exact path={path} component={ImportedContactList} /> */}
            <Route exact path={path} component={ImportedContactsLists} />
            <Route exact path={`${path}/:listId`} component={ListDetails} />
            {/* <Route path={`${path}`} component={Users} /> */}
        </Switch>
    );
}
